export const GenerateCourseModuleList = (moduleList: any) => {
  if (!moduleList || moduleList?.length === 0) return [];

  const modulesWithNextIds = moduleList?.map(
    (module: any) => module?.connectionList?.[0]?.nextModuleId
  );

  const firstModule = moduleList?.find(
    (module: any) => !modulesWithNextIds?.includes(module?.id)
  );
  const result = [];

  const startingModuleId = firstModule?.id;

  let currentId: string | null = startingModuleId;

  while (currentId) {
    if (currentId) {
      const currentModule = moduleList?.find(
        (module: any) => module?.id === currentId
      );
      if (currentModule && Object.keys(currentModule).length > 0) {
        result.push({ ...currentModule });
      }

      if (currentModule && currentModule?.connectionList?.length === 0) {
        currentId = null;
        break;
      }

      currentId =
        currentModule && currentModule?.connectionList?.[0]?.nextModuleId
          ? currentModule?.connectionList?.[0]?.nextModuleId
          : "";
    }
  }

  return result;
};
